var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BasicModal',{attrs:{"title":'一括送付',"isShowModal":_vm.isShowModal,"canCancel":true},on:{"cancel":_vm.cancel}},[_c('div',{staticClass:"bulk-action-container"},[_c('button',{staticClass:"button is-fullwidth is-primary",on:{"click":_vm.clickBulkSendEmail}},[_c('span',{staticClass:"mdi mdi-email"}),_vm._v("\n      メール一括送付\n    ")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29e20779","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChatBot/organisms/DetailMail.vue
// module id = null
// module chunks = 